import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

/**
 * Reusable SweetAlert2 confirmation with loader and toast.
 *
 * @param {{
 *   title?: string;
 *   text?: string;
 *   confirmText?: string;
 *   cancelText?: string;
 *   confirmColor?: string,
 *   cancelColor?: string,
 *   icon?: "warning" | "error" | "success" | "info" | "question";
 *   toastMessage?: string;
 *   toastError?: string;
 *   onConfirm: () => Promise<void> | void;
 * }} options
 */
export function CustomConfirmDialog({
    title = "Are you sure?",
    text = "This action cannot be undone.",
    confirmText = "Yes",
    cancelText = "No",
    confirmColor = "bg-red-600 hover:bg-red-700 text-white",
    cancelColor = "bg-gray-200 hover:bg-gray-300 text-gray-800",
    icon = "warning",
    toastMessage = "Action completed successfully!",
    toastError = "Something went wrong.",
    onConfirm,
}) {
    Swal.fire({
        title,
        text,
        icon,
        showCancelButton: true,
        confirmButtonText: confirmText,
        cancelButtonText: cancelText,
        reverseButtons: true,
        buttonsStyling: false,
        allowOutsideClick: () => !Swal.isLoading(),
        allowEscapeKey: () => !Swal.isLoading(),
        customClass: {
            popup: "rounded-lg p-5 w-full max-w-sm",
            title: "text-lg font-semibold text-gray-800",
            htmlContainer: "text-sm text-gray-700",
            confirmButton: `m-2 text-sm px-4 py-2 rounded shadow ${confirmColor}`,
            cancelButton: `m-2 text-sm px-4 py-2 rounded shadow ${cancelColor}`,
        },
        preConfirm: async () => {
            try {
                Swal.showLoading(); // Show loading spinner overlay
                await onConfirm?.(); // Execute async task
                return true; // Allow modal to close
            } catch (err) {
                Swal.hideLoading(); // Stop loading
                toast.error(toastError); // Show error toast
                throw err; // Prevent modal from closing
            }
        },
    }).then((result) => {
        if (result.isConfirmed) {
            toast.success(toastMessage); // Show success toast after modal closes
        }
    }).catch(err=>{
       // toast.error(toastError);
    });
}

